// extracted by mini-css-extract-plugin
export default {"inputWrapper":"text-input-module--input-wrapper--a397c","inputWrapperLegacy":"text-input-module--input-wrapper-legacy--e0f93"};